import Vue from "vue";
import Router from "vue-router";
// import HelloWorld from "@/components/HelloWorld";

Vue.use(Router);

var npush = Router.prototype.push;
Router.prototype.push = function (loction) {
  return npush.call(this, loction).catch((err) => err);
};

const router = new Router({
  routes: [
    {
      path: "/404",
      component: () => import("@/views/404"),
      hidden: true,
    },
    {
      path: "/",
      component: () => import("@/views/index"),
    },
    {
      path: "/about",
      component: () => import("@/views/about"),
    },
    {
      path: "/products",
      component: () => import("@/views/products"),
    },
    {
      path: "/productsmes",
      component: () => import("@/views/productsmes"),
    },
    {
      path: "/news",
      component: () => import("@/views/news"),
    },
    {
      path: "/newsmes",
      component: () => import("@/views/newsmes"),
    },
    {
      path: "/contact",
      component: () => import("@/views/contact"),
    }
  ],
});

router.beforeEach((to, from, next) => {
  // console.log("tototo", to);
  //每次进入滚动到页面顶部

  next();
  //每次进入滚动到页面顶部
  if (!to.query.navindex1) {
    window.scrollTo({
      top: 0,
    });
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js